export default "__VITE_ASSET__DZkfL0zC__"